import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const recordedFuture = defineConnector({
  identifier: "recordedFuture",
  name: "Recorded Future",
  tagLine: "Threat intelligence platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.recordedfuture\\.com/.*",
  auth: (app) => headerAuth([{ name: "X-RFToken", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Recorded Future](https://www.recordedfuture.com/) and generate an API token from your user settings.",
        },
      ],
    },
    {
      title: "Copy and paste the API token into the field below",
      items: [
        {
          kind: "input",
          label: "Recorded Future API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.recordedfuture.com/v2/info/whoami",
  },
});
